import { Button, Tooltip } from "@mui/material";

import { GqlPlannerV2VisitPossibleDaysStatus } from "~/__generated__";
import { VISIT_STATUS_TO_COLOR_MAP } from "~/config/statusColors";
import { formatDate } from "~/modules/app/util/formatters";

type TimelineDayProps = {
    day: Date;
    onClick?: (date: Date) => void;
    index: number;
    status: GqlPlannerV2VisitPossibleDaysStatus;
};

export function TimelineDay({ day, onClick, index, status }: TimelineDayProps) {
    const onClick_ = () => onClick?.(day);
    const buttonProps = onClick !== undefined ? { onClick: onClick_ } : { component: "span" };

    return (
        <Tooltip title={formatDate(day, "long")}>
            <Button
                {...buttonProps}
                sx={{
                    gridColumn: index + 1,
                    padding: 0,
                    gridRow: 2,
                    backgroundColor: VISIT_STATUS_TO_COLOR_MAP[status],
                    border: "1px solid rgba(255, 255, 255, .2)",
                    height: "100%",
                    minWidth: "2px",
                    cursor: onClick !== undefined ? "pointer" : "default",
                    transition: "transform 0.2s ease, border-color 0.2s ease",
                    borderRadius: 0,
                    "&:hover": {
                        transform: "scaleY(1.25)",
                        zIndex: 1,
                    },
                }}
            />
        </Tooltip>
    );
}
